/**
 * Invokes the code to assign branding to the app
 */

define(['edge/platform/branding/BrandingData'], (BrandingData)=> {
    // adds branding class to an HTML element
    document.documentElement.classList.add(`gw-branding-${BrandingData.BRANDING}`);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/branding/SetBranding.js